import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import Button from '@mui/material/Button'
import { Action } from '@@/action_pb'
import { eventLogProducer } from '@/lib/event-logger'

const resource = createResource({
  en: {
    mainTitle: `Let's Grow With Us`,
    btnText: 'Join us Now',
  },
  id: {
    mainTitle: 'Mari Berkembang Bersama Kami',
    btnText: 'Gabung Sekarang',
  },
})

const CareerBanner = () => {
  const { t } = useResource(resource)
  const url = 'https://www.linkedin.com/company/kreditpintar/?viewAsMember=true'
  const eventClick = () => {
    eventLogProducer.push({
      action: Action.JOINUSNOWBUTTONCLICK,
    })
  }
  return (
    <BannerBox>
      <div className="container">
        <div className="left-hook">
          <h1 className="main-title">{t('mainTitle')}</h1>
          <Button role="button" aria-disabled="false" className="career-btn" onClick={eventClick}>
            <a href={url} rel="noopener noreferrer nofollow" target="_blank">
              {t('btnText')}
            </a>
          </Button>
        </div>
      </div>
    </BannerBox>
  )
}

export default CareerBanner

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 61px;
    background-image: url('/images/career/career-banner-mobile.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      height: 534px;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      .left-hook {
        position: absolute;
        top: 60px;
        left: 24px;
        height: 150px;
        .main-title {
          font-size: 28px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          line-height: 32px;
        }
        .career-btn {
          height: 32px;
          padding: 0 12px;
          background: linear-gradient(270deg, #07e254 0%, #1cae4f 100%);
          border-radius: 6px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: Roboto-Bold, Roboto;
          font-weight: 500;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 100px auto 0;
    background-image: url('/images/career/career-banner-pc.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      height: 410px;
      width: 100%;
      max-width: 1440px;
      .left-hook {
        position: absolute;
        top: 100px;
        left: 170px;
        max-width: 520px;
        height: 240px;
        .main-title {
          font-size: 44px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.87);
          line-height: 44px;
        }
        .career-btn {
          padding: 0 12px;
          height: 40px;
          background: linear-gradient(270deg, #07e154 0%, #1dae4d 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 24px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }
`
